import React, { useState } from 'react';

const faqData = [
  {
    question: 'Это официальный сервис T-Bank?',
    answer: 'Пока нет. T-Interest — независимый проект, созданный для общения сотрудников.',
  },
  {
    question: 'Кто видит мой профиль?',
    answer: 'Только пользователи платформы.',
  },
  {
    question: 'Можно ли просто наблюдать и не писать?',
    answer: 'Да. Ты сам выбираешь комфортный формат участия.',
  },
  {
    question: 'Это похоже на дейтинг?',
    answer: 'Нет. Это сервис исключительно про интересы, хобби и сообщества.',
  },
];

function FAQSection() {
  const [openIndices, setOpenIndices] = useState([]);
  const desktopRows = [];

  for (let idx = 0; idx < faqData.length; idx += 2) {
    desktopRows.push(faqData.slice(idx, idx + 2));
  }

  const handleToggle = (idx) => {
    setOpenIndices((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx],
    );
  };

  const renderFaqItem = (item, idx) => {
    const isOpen = openIndices.includes(idx);

    return (
      <div key={idx} className="home-faq-item relative">
        <button
          className="home-faq-item-btn flex items-center w-full text-left transition font-tt-norms font-medium"
          style={{ color: 'var(--faq-title-text)' }}
          onClick={() => handleToggle(idx)}
        >
          <span
            className="home-faq-item-icon-slot mr-5 flex items-center justify-center w-12 h-12 text-[1rem]"
            style={{ color: 'var(--faq-icon-text)' }}
          >
            {isOpen ? (
              <span
                className="rounded-full w-12 h-12 flex items-center justify-center"
                style={{ backgroundColor: 'var(--faq-open-bg)' }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6 10L12 16L18 10"
                    stroke="var(--faq-icon-open-foreground)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            ) : (
              <span
                className="rounded-full w-12 h-12 flex items-center justify-center"
                style={{ backgroundColor: 'var(--faq-closed-bg)' }}
              >
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M10 6L16 12L10 18"
                    stroke="var(--faq-icon-closed-foreground)"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </span>
          <span className="home-faq-item-question">{item.question}</span>
        </button>

        {isOpen && (
          <div
            className="home-faq-item-answer font-tt-norms font-light"
            style={{
              color: 'var(--faq-answer-text)',
              backgroundColor: 'var(--faq-answer-bg)',
            }}
          >
            {item.answer}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="w-full home-faq-top-gap" style={{ backgroundColor: 'var(--faq-page-bg)' }}>
      <div className="layout-12 mx-auto pl-0 pr-0">
        <p className="section-title-main home-faq-title flex justify-center text-center md:justify-start md:text-left">
          У тебя остались какие-либо вопросы?
        </p>
        <p
          className="home-faq-subtitle flex items-center justify-center font-tt-norms md:justify-start font-normal"
          style={{ color: 'var(--faq-title-text)' }}
        >
          Прочитай популярные ответы ниже
        </p>

        <div className="home-faq-list-mobile md:hidden space-y-6">
          {faqData.map((item, idx) => renderFaqItem(item, idx))}
        </div>

        <div className="home-faq-list-desktop hidden md:flex md:flex-col md:gap-y-6">
          {desktopRows.map((row, rowIdx) => (
            <div key={rowIdx} className="home-faq-desktop-row md:grid md:grid-cols-2 md:gap-x-6">
              {row.map((item, colIdx) => renderFaqItem(item, rowIdx * 2 + colIdx))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FAQSection;
